export default "__VITE_ASSET__DeJ5ZUCF__"